module.exports = {

    'common' : {
        'noResults' : 'No existen resultados para esta búsqueda',
        'btnConfirm' : '¿Estás seguro/a?'
    },

    'labels' : {
        'choice_city' : 'Selecciona una ciudad',
        'choice_event':    'Selecciona un evento',
        'choice_default': 'Escribe o selecciona uno',

    },

    'calendar' : {
        'eventAdd'         : 'Evento añadido',
        'eventRefused'     : 'Evento rechazado',
        'addToCalendar'    : 'añadir a mi calendario',
        'noSuggestMore'    : 'No sugerir de nuevo',
        'eventDates'       : '{0} a {1}',

        'titles' : {
            'suggested'         : 'Ferias sugeridas',
            'searchByName'      : 'Filtra Fería por nombre',
            'searchByGeo'       : 'Filtra por país',
            'addTradeshows'     : 'Añade tus próximas ferias',
            'nextTradeshows'    : 'Próximas ferias dónde tienes stands contratados'
        },

        'buttons' : {
            'addTradeshows'     : 'Añadir feria',
            'filter'            : 'Filtrar',
            'myTradeshows'      : 'Ir a mis ferias',
            'filterByLocation'  : 'Filtrar por Localización',
            'filterByName'      : 'Filtrar por nombre',
            'addToCalendar'     : 'añadir a mi calendario',
        },

        'labels' : {
            'where' : 'Donde',
            'begin' : 'Inicio',
            'end'   : 'Final',
            'filterByCity'  : 'Filtra por ciudad',
            'filterByCity2' : 'Ciudad dónde se celebra',
            'filterByMonth' : 'Escribe un mes de inicio',
            'filterByDates' : 'Fechas'
        },

        'text' : {
            'suggested'                 : 'En base a la información que guardamos de ferias en las que has trabajado y a las ferias que son populares en tu país esta es una selección de ferias en las que tal vez tengas ya trabajos programados. De ser así, añádelas a tu calendario!',
            'suggestedBy'               : 'Ferias sugeridas en base a',
            'suggestedByHistory'        : 'Mi Historial como constructor',
            'suggestedByLeads'          : 'Leads aceptados',
            'suggestedByNearlyEvents'   : 'Ferias en radio 100Km',
            'suggestedByRelevantEvents' : 'Ferias relevantes en 800Km',
            'notFindEvent'              : 'No hemos encontrado {0} en nuestro calendario. Dinos dónde y cuando se celebra para que la podamos añadir a tu calendario.',
            'workIndicated'             : 'Has indicado que tal vez trabajes:',
            'confirmEvent'              : 'confirmar feria',
            'myHistoryExplanation'      : 'Te sugerimos ferias en las que nos consta que has trabajado en el pasado o has mostrado interés en trabajar en ellas.',
            'acceptedLeadsExplanation'  : 'Te sugerimos aquellas ferias en las que has aceptado leads.',
            'relevantEventsExplanation' : 'Te mostramos las próximas ferias que se celebran en un radio de {0} Km de tu sede central.',
            'suggestedExplanation'      : 'Selecciona aquellas en las que trabajarás en la próxima edición.',


        },
    },
};


// WEBPACK FOOTER //
// ./resources/js/i18n/calendar/es.js